import { Component, inject, TemplateRef, ViewChild } from "@angular/core";
import {FormControl,UntypedFormBuilder,} from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Template } from "aws-sdk/clients/pcaconnectorad";
import { ToastrService } from "ngx-toastr";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { OrdersService } from "src/app/core/services/orders.service";

@Component({
  selector: "app-order-tracking",
  templateUrl: "./order-tracking.component.html",
  styleUrls: ["./order-tracking.component.scss"],
})
export class OrderTrackingComponent {


  headerData: any;
  ogData: any;
  customers: any;
  fullData: any;
  apiData: any = [];
  pageSize: number = 20;
  superuser: any;
  d2c_name: any;
  portal_name: any;
  portal_account_id: any;
  portal_id: any;
  showOverlay = false;
  length = 0;
  page_no: number = 1;
  minDate = new Date(); 
  maxDate = new Date(); 
  
  displayedColumns: string[] | undefined;
  @ViewChild(MatPaginator, { static: true }) paginator: | MatPaginator | undefined;
  @ViewChild(MatSort, { static: false }) sort: MatSort | undefined;
  
  private modalService = inject(NgbModal);
  fulllength: any;



  // Filter Value Goes Here
  statusForm = new FormControl('');
  courierPartnerForm = new FormControl('');
  attemptStatusForm = new FormControl('');
  searchControlForm = new FormControl('');
  orderStartDateForm : any = new FormControl('');
  orderEndDateForm : any = new FormControl('');
  dispatchByDateStartForm : any = new FormControl('');
  dispatchByDateEndForm : any = new FormControl('');
  firstAttemptDateForm : any = new FormControl('');
  secondAttemptDateForm : any = new FormControl('');
  thirdAttemptDateForm : any = new FormControl('');

  constructor(
    private _order: OrdersService,
    private toastr: ToastrService,
    private router: Router,
  ) {}


  ngOnInit(): void {
    let cuurentDate = new Date();
    this.minDate.setDate(cuurentDate.getDate() - 60); 
    this.superuser = localStorage.getItem("is_superuser");
    this.superuser = localStorage.getItem("is_superuser");
    if (this.superuser == "true") {
      this.portal_name = localStorage.getItem("portal_name2");
      this.portal_id = localStorage.getItem("portal_id2");
      this.portal_account_id = localStorage.getItem("portal_account_id2");
      this.d2c_name = localStorage.getItem("d2c_name2");
    } else {
      this.portal_name = localStorage.getItem("portal_name");
      this.portal_id = localStorage.getItem("portal_id");
      this.portal_account_id = localStorage.getItem("portal_account_id");
      this.d2c_name = localStorage.getItem("d2c_name");
    }
    this.fetchData();
  }

  changedateFormate(data:any){
    let date = new Date(data);
    const month = String(date.getMonth()+1).padStart(2,'0');
    const day = String(date.getDate()).padStart(2,'0');
    return `${date.getFullYear()}-${month}-${day}`;
  }


  fetchData() {
    this.superuser = localStorage.getItem("is_superuser");
    if (this.superuser == "true") {
      this.portal_name = localStorage.getItem("portal_name2");
      this.portal_id = localStorage.getItem("portal_id2");
      this.portal_account_id = localStorage.getItem("portal_account_id2");
      this.d2c_name = localStorage.getItem("d2c_name2");
    } else {
      this.portal_name = localStorage.getItem("portal_name");
      this.portal_id = localStorage.getItem("portal_id");
      this.portal_account_id = localStorage.getItem("portal_account_id");
      this.d2c_name = localStorage.getItem("d2c_name");
    }
    this.showOverlay = true;

    const param = new URLSearchParams();
    param.set('page',String(this.page_no));
    param.set('size',String(this.pageSize));
    param.set('portal_account_id',String(this.portal_account_id));
    const currentDate = new Date();
    if(this.searchControlForm.value != '') param.set('search',String(this.searchControlForm.value));
    if(this.courierPartnerForm.value != '') param.set('courier_partner',String(this.courierPartnerForm.value));
    if(this.attemptStatusForm.value != '') param.set('attempt_status',String(this.attemptStatusForm.value));
    if(this.statusForm.value != '') param.set('status',String(this.statusForm.value));
    if(this.orderStartDateForm.value !=''  ){
      if(this.orderEndDateForm.value!='' && this.orderEndDateForm.value!=null && this.orderEndDateForm.value !=undefined ){
        param.set('start_date',`${this.changedateFormate(this.orderStartDateForm.value)}`);
        param.set('end_date',`${this.changedateFormate(this.orderEndDateForm.value)}`)
      }
      else{
        param.set('start_date',`${this.changedateFormate(this.orderStartDateForm.value)}`);
        param.set('end_date',`${this.changedateFormate(currentDate)}`);
      }
    } 
    else{
      param.set('start_date',`${this.changedateFormate(this.minDate)}`);
    }
    if(this.dispatchByDateStartForm.value !=''  ){
      if(this.dispatchByDateEndForm.value!='' && this.dispatchByDateEndForm.value!=null && this.dispatchByDateEndForm.value !=undefined ){
        param.set('dispatch_start_date',`${this.changedateFormate(this.dispatchByDateStartForm.value)}`);
        param.set('dispatch_end_date',`${this.changedateFormate(this.dispatchByDateEndForm.value)}`)
      }
      else{
        param.set('dispatch_start_date',`${this.changedateFormate(this.dispatchByDateStartForm.value)}`);
        param.set('dispatch_end_date',`${this.changedateFormate(currentDate)}`);
      }
    } 
    if(this.firstAttemptDateForm.value!='' && this.firstAttemptDateForm.value!=null && this.firstAttemptDateForm.value !=undefined ){
      param.set('first_attempt_date',`${this.changedateFormate(this.firstAttemptDateForm.value)}`);
    }
    if(this.secondAttemptDateForm.value!='' && this.secondAttemptDateForm.value!=null && this.secondAttemptDateForm.value !=undefined ){
      param.set('second_attempt_date',`${this.changedateFormate(this.secondAttemptDateForm.value)}`);
    }
    if(this.thirdAttemptDateForm.value!='' && this.thirdAttemptDateForm.value!=null && this.thirdAttemptDateForm.value !=undefined ){
      param.set('third_attempt_date',`${this.changedateFormate(this.thirdAttemptDateForm.value)}`);
    }


    this._order.orderTrackingApi(param).subscribe((response: any) => {
        let mes = JSON.parse(response);
        if (mes.Data.length > 0) {  this.length = mes.total_length; this.fulllength = mes.total_length; }
        if (mes.statusCode === 200) {
          this.showOverlay = false;
          this.fullData = mes.Data;
          this.ogData = mes.Data;
          this.headerData = mes.headers;
          this.getData(this.fullData);
          this.modalService.dismissAll("Close click");
        } else {
          if ( mes.error == "Token has expired" ||  mes.error == "Invalid token" ||  mes.error == "Token is required") {
            this.showOverlay = false;
            this.router.navigate(["/auth/login"]);
          } else {
            this.toastr.error(mes.error, "");
            this.showOverlay = false;
          }
        }
      },
      (error) => {
        this.showOverlay = false;
        if (error.status === 502) {
          this.toastr.error("502 Bad Gateway", "An error occurred");
        } else {
          this.toastr.error(  "An error occurred while communicating with the server.","Please Try Again After some time",);
        }
      },
    );
  }
 

  getData(data: any) {
    this.apiData = data;
    delete this.headerData.portal_account_id;

    this.displayedColumns = Object.keys(this.headerData);
    this.customers = new MatTableDataSource(this.apiData);
    this.customers.sort = this.sort;
  }

  searchValue(filterValue:string){
    if(filterValue!=''){
      this.paginator.pageIndex=0
      this.paginator.pageSize=20
      this.page_no=1
      this.pageSize=20
      this.fetchData();
    }
  }

  paginatorDropdown(event: PageEvent) {
    this.showOverlay=true
    this.pageSize = event.pageSize;
    this.page_no = 1;
    this.fetchData()
  }


  syncPrimaryPaginator(event: PageEvent) {
    this.paginator.pageIndex = event.pageIndex;
    this.paginator.pageSize = event.pageSize;
    this.page_no = event.pageIndex + 1;
    this.fetchData();
  }

  closedDateFilter(type:any){
    if(type=='dispatch'){
      this.dispatchByDateStartForm.setValue('');
      this.dispatchByDateEndForm.setValue('');
    }
    if(type=='order'){
      this.orderStartDateForm.setValue('');
      this.orderEndDateForm.setValue('');
    }
    if(type=='first'){
      this.firstAttemptDateForm.setValue('');
    }
    if(type=='second'){
      this.secondAttemptDateForm.setValue('');
    }
    if(type=='third'){
      this.thirdAttemptDateForm.setValue('');
    }
    this.closedFilter();
  }

  closedFilter() {
    this.paginator.pageIndex=0
    this.paginator.pageSize=20
    this.page_no=1
    this.pageSize=20
    this.fetchData();
  }

  resetFilters(){
    this.paginator.pageIndex=0;
    this.paginator.pageSize=20;
    this.page_no=1;
    this.pageSize=20;
    this.statusForm.setValue('');
    this.searchControlForm.setValue('');
    this.attemptStatusForm.setValue('');
    this.courierPartnerForm.setValue('');
    this.dispatchByDateStartForm.setValue('');
    this.dispatchByDateEndForm.setValue('');
    this.orderStartDateForm.setValue('');
    this.orderEndDateForm.setValue('');
    this.firstAttemptDateForm.setValue('');
    this.secondAttemptDateForm.setValue('');
    this.thirdAttemptDateForm.setValue('');
    this.fetchData();
  }

  statusData : any = [
    "Payment Pending",
    "Payment Success",
    "Created",
    "Packed",
    "Dispatched",
    "In Transit",
    "Delivered",
    "Cancelled",
    "Return Requested",
    "Customer Return",
    "Cr-Received",
    "Rto-In Transit",
    "Rto",
    "Out For Delivery",
    "Shiplable Generated"
  ]




  @ViewChild('overviewDetailsTemp') overviewDetailsTemp! : TemplateRef<any>;
  overViewDetails : any = [];
  openScanDetailsView(row:any){
    this.modalService.open(this.overviewDetailsTemp,{centered:true,size:'xl'});
    this.overViewDetails = row.scan_details;
  }

  modalClose(){
    this.modalService.dismissAll();
  }


  downloadOrder(){
    this.superuser = localStorage.getItem("is_superuser");
    if (this.superuser == "true") {
      this.portal_name = localStorage.getItem("portal_name2");
      this.portal_id = localStorage.getItem("portal_id2");
      this.portal_account_id = localStorage.getItem("portal_account_id2");
      this.d2c_name = localStorage.getItem("d2c_name2");
    } else {
      this.portal_name = localStorage.getItem("portal_name");
      this.portal_id = localStorage.getItem("portal_id");
      this.portal_account_id = localStorage.getItem("portal_account_id");
      this.d2c_name = localStorage.getItem("d2c_name");
    }
    this.showOverlay = true;

    const param = new URLSearchParams();
    param.set('page',String(this.page_no));
    param.set('size',String(this.pageSize));
    param.set('download',String(true));
    param.set('portal_account_id',String(this.portal_account_id));
    const currentDate = new Date();
    if(this.searchControlForm.value != '') param.set('search',String(this.searchControlForm.value));
    if(this.courierPartnerForm.value != '') param.set('courier_partner',String(this.courierPartnerForm.value));
    if(this.attemptStatusForm.value != '') param.set('attempt_status',String(this.attemptStatusForm.value));
    if(this.statusForm.value != '') param.set('status',String(this.statusForm.value));
    if(this.orderStartDateForm.value !=''  ){
      if(this.orderEndDateForm.value!='' && this.orderEndDateForm.value!=null && this.orderEndDateForm.value !=undefined ){
        param.set('start_date',`${this.changedateFormate(this.orderStartDateForm.value)}`);
        param.set('end_date',`${this.changedateFormate(this.orderEndDateForm.value)}`)
      }
      else{
        param.set('start_date',`${this.changedateFormate(this.orderStartDateForm.value)}`);
        param.set('end_date',`${this.changedateFormate(currentDate)}`);
      }
    } 
    else{
      param.set('start_date',`${this.changedateFormate(this.minDate)}`);
    }
    if(this.dispatchByDateStartForm.value !=''  ){
      if(this.dispatchByDateEndForm.value!='' && this.dispatchByDateEndForm.value!=null && this.dispatchByDateEndForm.value !=undefined ){
        param.set('dispatch_start_date',`${this.changedateFormate(this.dispatchByDateStartForm.value)}`);
        param.set('dispatch_end_date',`${this.changedateFormate(this.dispatchByDateEndForm.value)}`)
      }
      else{
        param.set('dispatch_start_date',`${this.changedateFormate(this.dispatchByDateStartForm.value)}`);
        param.set('dispatch_end_date',`${this.changedateFormate(currentDate)}`);
      }
    } 
    if(this.firstAttemptDateForm.value!='' && this.firstAttemptDateForm.value!=null && this.firstAttemptDateForm.value !=undefined ){
      param.set('first_attempt_date',`${this.changedateFormate(this.firstAttemptDateForm.value)}`);
    }
    if(this.secondAttemptDateForm.value!='' && this.secondAttemptDateForm.value!=null && this.secondAttemptDateForm.value !=undefined ){
      param.set('second_attempt_date',`${this.changedateFormate(this.secondAttemptDateForm.value)}`);
    }
    if(this.thirdAttemptDateForm.value!='' && this.thirdAttemptDateForm.value!=null && this.thirdAttemptDateForm.value !=undefined ){
      param.set('third_attempt_date',`${this.changedateFormate(this.thirdAttemptDateForm.value)}`);
    }


    this._order.orderTrackingApi(param).subscribe((response: any) => {
        let mes = JSON.parse(response);
        if (mes.statusCode == 200) {
          this.showOverlay = false;
          window.open(mes.file_link,'_blank')
        } else {
          if ( mes.error == "Token has expired" ||  mes.error == "Invalid token" ||  mes.error == "Token is required") {
            this.showOverlay = false;
            this.router.navigate(["/auth/login"]);
          } else {
            this.toastr.error(mes.error, "");
            this.showOverlay = false;
          }
        }
      },
      (error) => {
        this.showOverlay = false;
        if (error.status === 502) {
          this.toastr.error("502 Bad Gateway", "An error occurred");
        } else {
          this.toastr.error(  "An error occurred while communicating with the server.","Please Try Again After some time",);
        }
      },
    );
  }


}
